module.exports = __webpack_public_path__ + "static/media/magic-wand-plus.31617131.webp";